module.exports = __webpack_public_path__ + "img/banner_cover_home.66e0ed2d.jpg";